module.exports = __webpack_public_path__ + "img/inco5.66f8c08c.png";